module.exports = __webpack_public_path__ + "../resources/img/ic_re_no4_p2_line_wh.f91cad56.svg";